import { fftDirectDimension, } from '../../../xyz/util/fft2d/fftDirectDimension';
import { xAdd, xEnsureFloat64, xMultiply, xSubtract, } from 'ml-spectra-processing';
export const id = 'fftDimension1';
export const name = 'FFT Dimension 1';
export const DOMAIN_UPDATE_RULES = {
    updateXDomain: true,
    updateYDomain: true,
};
export function apply(datum2D, options) {
    if (!isApplicable(datum2D)) {
        throw new Error('fft dimension 1 not applicable on this data');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { data, info } = datum2D;
    const { digitalFilter: digitalFilterValue = 0 } = info;
    const fnMode = info.fnMode[1].toLowerCase();
    const orderedData = fnMode === 'echo-antiecho'
        ? echoQuadrature(data)
        : {
            re: data.re.z,
            im: data.im.z,
        };
    const { zeroFilling = {} } = options;
    const nbColumns = orderedData.re[0].length;
    const { factor = 1 } = zeroFilling;
    const nbPoints = zeroFilling?.nbPoints || 2 ** Math.round(Math.log2(nbColumns * factor));
    const transformed = fftDirectDimension(orderedData, {
        fnMode,
        ...options,
        digitalFilterValue,
        zeroFilling: { nbPoints },
    });
    datum2D.data.re.z = transformed.re.to2DArray().map(xEnsureFloat64);
    datum2D.data.im.z = transformed.im.to2DArray().map(xEnsureFloat64);
}
export function isApplicable(datum2D) {
    if (datum2D.info.isComplex && datum2D.info.isFid)
        return true;
    return false;
}
export function reduce() {
    return {
        once: true,
        reduce: undefined,
    };
}
function echoQuadrature(data) {
    const { re: { z: reMatrix }, im: { z: imMatrix }, } = data;
    const newRe = [];
    const newIm = [];
    for (let i = 0; i < reMatrix.length; i += 2) {
        const reCosine = reMatrix[i];
        const imCosine = imMatrix[i];
        const reSine = reMatrix[i + 1];
        const imSine = imMatrix[i + 1];
        newRe.push(xSubtract(xMultiply(imSine, -1), imCosine));
        newRe.push(xSubtract(reSine, reCosine));
        newIm.push(xAdd(reSine, reCosine));
        newIm.push(xSubtract(imSine, imCosine));
    }
    return { re: newRe, im: newIm };
}
//# sourceMappingURL=fftDimension1.js.map